<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header--title">
      <h2 class="pb-0" data-translation-key="buyer_catalogue_sale_statistics">
        {{ 'buyer_catalogue.sale_statistics' | translate }}
      </h2>
    </div>
    <span mat-dialog-close class="pb-0">
      <img src="../../../../../../../assets/images/close.svg" alt="close" />
    </span>
  </div>
  <div class="stats-container">
    @for (stat of stats; track stat) {
      <p class="d-flex justify-content-between">
        <span class="key">{{ stat.label | translate }} </span>
        <span class="value">{{ stat.value }}</span>
      </p>
    }
  </div>
  <div class="dialog-footer">
    <button
      class="btn close-btn w-100"
      (click)="onClose()"
      data-translation-key="buyer_catalogue_close"
      >
      {{ 'buyer_catalogue.close' | translate }}
    </button>
  </div>
</div>
